import React from 'react';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';

function Autolettura({setData, step, setStep, data}) {
   
  return (
    <div className="autolettura">
        <div className="text">
            <p className="main">Invio autolettura</p>
            <p className="secondary">
                Con Revoluce non è obbligatorio comunicare l’autolettura del contatore: questo dato può però esserci utile nel caso in cui il tuo distributore ci comunichi in ritardo (o non ci comunichi affatto) i consumi di questo mese. 
            </p>
            <div className="box">
                <p>Puoi inviarci l'autolettura nel periodo di tempo che va dal 28 al 3 di ogni mese.</p>
            </div>
        </div>
        <div className="formAutolettura">
            <div className="item">
                <p className="label">Data ( Giorno in cui hai preso la lettura )</p>
                <input type="date"  name="data" id="data" onChange={(e) => setData(prevState => ({...prevState, data: e.target.value}))}/>
            </div>
            <div className="item">
                <p className="label">A1</p>
                <input type="number" placeholder='Es. 2922'  name="a1" id="a1" onChange={(e) => setData(prevState => ({...prevState, a1: e.target.value}))}/>
            </div>
            <div className="item">
                <p className="label">A2</p>
                <input type="number" placeholder='Es. 2922'  name="a2" id="a2" onChange={(e) => setData(prevState => ({...prevState, a2: e.target.value}))}/>
            </div>
            <div className="item">
                <p className="label">A3</p>
                <input type="number" placeholder='Es. 2922'  name="a3" id="a3" onChange={(e) => setData(prevState => ({...prevState, a3: e.target.value}))}/>
            </div>
        </div>
        <div className="buttonContainer relative">
            <button disabled={data.data && data.a1 && data.a2 && data.a3 ? false : true} onClick={() => setStep(step + 1)}>Invia nuova lettura <ArrowForwardIos/></button>
        </div>
    </div>
  );
}

export default Autolettura;
